import { useUndo } from "../../Utils/undo";
import React, { useEffect, useContext, useState, useRef } from "react";
import MyContext from "../../context/MyContext";
import TickerContext from "../../context/ticker";
import Lottie from "lottie-web";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import AuthContext from "../../context/userAuth.context";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import ProjectContext from "../../context/ProjectContext";

// import characterPopup from '../../TextToSpeech/characterPopup'

const Toolbar = ({
  values,
  type,
  parentWidth,
  parentHeight,
  TextRef,
  JSONValue,
  isStanding,
  setIsStanding,
  isTTS,
  setIsTTS,
}) => {
  const { setGoto } = useContext(TickerContext);
  const { authenticationData } = useContext(AuthContext);
  const [fontsize, setfontsize] = useState();
  const [audios, setAudios] = useState(false);

  const {
    setLayersData,
    CharacterLoader,
    LayersData,
    clone,

    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    ChangeCount,
    setChangeCount,
    EditorZoom,
    setCharacterEditor,
    characterId,
    setCharacterId,
    seteditableObject,
  } = useContext(MyContext);
  const undo = useUndo();

  const { slides, setslides } = useContext(ProjectContext);

  var currsize;

  const [position, setposition] = useState({
    y: (values.y * EditorZoom) / 100,
    x: (values.x * EditorZoom) / 100,
  });

  const StackStore = () => {
    return new Promise((resolve) => {
      let stack = [...UndoLayer];
      let PrevArray = clone(LayersData);
      if (stack.length < 10) {
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      } else {
        stack.shift();
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      }
      resolve();
    });
  };

  const SettingShow = async (e) => {
    const array = Array.from(LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].toolbar = false;
        array[i].FurtherSetting = true;
        array[i].DrapEndAnimatedText = true;
        break;
      }
    }
    setLayersData(array);
    // The settings popup next to the layer is hidden (all settings moved to the left panel), so
    // the gear opened nothing: open the layer's settings in the left panel.
    if (seteditableObject) seteditableObject({ showPanel: true, editableItem: values });
  };

  const FlipFun = async (e) => {
    await StackStore();

    const array = Array.from(LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (array[i].flip === "scaleX(1)") {
          array[i].flip = "scaleX(-1)";
        } else {
          array[i].flip = "scaleX(1)";
        }
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const lockFun = async (e) => {
    undo("lockFun"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].lock = !array[i].lock;
        array[i].layerlock = true;
        array[i].Editable = false;
        array[i].toolbar = false;
        break;
      }
    }
    setLayersData(array);
  };

  const deleteFun = () => {
    undo("deleteFun"); // Ctrl+Z goes back to before this change
    // debugger;
    setIsTTS(false);
    var array = Array.from(LayersData);
    let changeArray = array.filter(function (value, index, arr) {
      if (value.toolbar !== true) {
        value.Added = true;
        return value;
      } else {
        Lottie.destroy(value.AnimationId);
      }

      // if (value.key !== values.key) {
      //   return value;
      // } else {
      //   if (value.type == "Props") {
      //     Lottie.destroy(value.AnimationId);
      //   } else if (value.type == "Character") {
      //     Lottie.destroy(value.AnimationId);
      //   }
      // }
    });

    // const _slides = Array.from(slides);

    // const active_slides = _slides.find(x => x.IsActive === true);

    // active_slides.LayerData = changeArray;

    // if(active_slides.LayerData[0])
    // {
    //   active_slides.LayerData[0].deleted = true;
    // }
    // else
    // {
    //   active_slides.deleted = true;
    // }

    // setTimeout(() => {
    //   setslides(_slides)
    // }, 7000);

    setLayersData(changeArray);
  };
  //

  const audiomodal = async (e) => {
    // debugger;
    let change = false;
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].isTTS = true;
        change = true;
        //array[i].Editable = false;
        break;
      }
    }

    if (change) {
      setLayersData(array);
    }
  };
  const [DecrMouseDownInterval, setDecrMouseDownInterval] = useState(null);
  const [IncrMouseDownInterval, setIncrMouseDownInterval] = useState(null);
  const decrSizeMouseDown = () => {
    setDecrMouseDownInterval(setInterval(decrSize, 33));
  };
  const decrSizeMouseUp = () => {
    if (DecrMouseDownInterval) {
      clearInterval(DecrMouseDownInterval);
      setChangeCount((prevCount) => prevCount + 1);
    }
  };

  const incrSizeMouseDown = () => {
    setIncrMouseDownInterval(setInterval(incrSize, 33));
  };

  const incrSizeMouseUp = () => {
    if (IncrMouseDownInterval) {
      clearInterval(IncrMouseDownInterval);
      setChangeCount((prevCount) => prevCount + 1);
    }
  };

  const decrSize = async (e) => {
    await StackStore();
    currsize = values.fontSize;
    currsize = parseInt(currsize) - 1;
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].fontSize = currsize;
        array[i].originalFontSize = currsize;
        let elm = document.getElementById("Text-" + values.AnimationId);
        let text = document.getElementById(
          "Text-" + values.AnimationId
        ).offsetParent;
        if (text.offsetWidth < elm.offsetWidth) {
          array[i].width = elm.offsetWidth;
        } else {
          array[i].width = text.offsetWidth;
        }
        if (text.offsetHeight < elm.offsetHeight) {
          array[i].height = elm.offsetHeight;
        } else {
          array[i].height = text.offsetHeight;
        }
        array[i].isFontButtonClick = true;
        break;
      }
    }
    setLayersData(array);
  };

  const incrSize = async (e) => {
    await StackStore();
    currsize = values.fontSize;
    currsize = parseInt(currsize) + 1;
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].fontSize = currsize;
        array[i].originalFontSize = currsize;
        let elm = document.getElementById("Text-" + values.AnimationId);
        let text = document.getElementById("Text-" + values.AnimationId)
          ?.offsetParent?.offsetParent;
        if (text.offsetWidth < elm.offsetWidth) {
          array[i].width = elm.offsetWidth;
          array[i].originalWidth = elm.offsetWidth;
        } else {
          array[i].width = text.offsetWidth;
          array[i].originalWidth = text.offsetWidth;
        }
        if (text.offsetHeight < elm.offsetHeight) {
          array[i].originalHeight = elm.offsetHeight;
          array[i].height = elm.offsetHeight;
        } else {
          array[i].height = text.offsetHeight;
          array[i].originalHeight = text.offsetHeight;
        }
        array[i].isFontButtonClick = true;
        break;
      }
    }
    setLayersData(array);
  };
  useEffect(() => {
    if (values.character_FilePath != undefined) {
      if (values.character_FilePath.includes("Standing")) {
        setIsStanding(true);
      }
    }
  }, []);
  useEffect(() => {
    if (values.fontSize != null) {
      var Fsize = values.fontSize;
      setfontsize(Fsize);
    }
  }, [values.fontSize]);
  useEffect(() => {
    setCharacterEditor(false);
    if (values.y < parentHeight && values.x < parentWidth) {
      if (values.y < 40) {
        setposition({ x: (values.x * EditorZoom) / 100, y: 40 });
      } else if (values.x < 0) {
        setposition({ x: 0, y: (values.y * EditorZoom) / 100 });
      } else if (values.y < 40 && values.x < 0) {
        setposition({ x: 0, y: 40 });
      } else if (values.y > 40 && values.x > 0) {
        setposition({
          x: (values.x * EditorZoom) / 100,
          y: (values.y * EditorZoom) / 100,
        });
      } else if (parentWidth - (values.x + 42) < values.width) {
        let newPosition = values.width - (parentWidth - (values.x + 42));
        setposition({
          x: values.x - newPosition,
        });
      } else if (
        parentWidth - (values.x + 42) < values.width &&
        values.y < 40
      ) {
        let newPosition = values.width - (parentWidth - (values.x + 42));
        setposition({
          x: values.x - newPosition,
          y: 40,
        });
      }
    }
  }, [values]);

  const Swaped = (params) => {
    undo("Swaped"); // Ctrl+Z goes back to before this change
    // params.currentTarget.parentElement.parentElement.parentElement.previousElementSibling.style.border =
    //   "4px dotted red";

    var obj;
    if (type == "Character") {
      obj = {
        menu: type,
        innerMenu: "Char",
        key: values.key,
      };
    } else if (type == "Props") {
      obj = {
        menu: type,
        innerMenu: "prop",
        key: values.key,
      };
    } else if (type == "Shape") {
      obj = {
        menu: type,
        innerMenu: "shape",
        key: values.key,
      };
    } else if (type == "image") {
      obj = {
        menu: type,
        innerMenu: "img",
        key: values.key,
      };
    } else if (type == "Video") {
      obj = {
        menu: type,
        innerMenu: "vid",
        key: values.key,
      };
    }
    const array = Array.from(LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].IsVideoSwap = true;
        break;
      }
    }
    setLayersData(array);
    setGoto(obj);
  };
  const toolbarRef = useRef(null);

  const EditModernCharacter = () => {
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        setCharacterId(values.AnimationId);
        break;
      }
    }
    setCharacterEditor(true);
  };

  return (
    <>
      <div
        ref={toolbarRef}
        className="toolbar_Container"
        style={{ left: position.x, top: position.y - 40, display: "none" }}
      >
        <div className="ToolBarAction">
          {type === "text" && (
            <div className="FurtherActions" data_set="color_Picker">
              <div className="FurtherActionsInnerTextSize">
                <div className="InnerInputPill" data_set="lock_object">
                  <div>
                    <span
                      className="material-icons minusSpan"
                      tabIndex="0"
                      onMouseDown={decrSizeMouseDown}
                      onMouseUp={decrSizeMouseUp}
                    >
                      remove_circle_outline
                    </span>
                  </div>
                  <input
                    className="furtherActionInput"
                    defaultValue={fontsize}
                    tabIndex="0"
                  />
                  <div>
                    <span
                      className="material-icons PlusSpan"
                      tabIndex="0"
                      onMouseDown={incrSizeMouseDown}
                      onMouseUp={incrSizeMouseUp}
                    >
                      add_circle_outline
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {type !== "basicShape" && type !== "text" && type !== "AnimatedText" && (
            <div className="FurtherActions" data_set="Swap_object">
              <div
                className="FurtherActionInner FurtherActionInnerButton"
                onClick={Swaped}
              >
                <div className="actionIconStyle">
                  <div className="SwapSpan">
                    <span className="material-icons" tabIndex="0">
                      swap_horiz
                    </span>
                    <span className="swapText">SWAP</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="FurtherActions" data_set="lock_object">
            <div
              className="FurtherActionInner FurtherActionInnerButton"
              data_set="lock_object"
            >
              <div className="actionIconStyle">
                <div className="SwapSpan">
                  <span
                    className="material-icons "
                    tabIndex="0"
                    onClick={lockFun}
                  >
                    lock
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="FurtherActions" data_set="delete_object">
            <div
              className="FurtherActionInner FurtherActionInnerButton"
              data_set="lock_object"
            >
              <div className="actionIconStyle">
                <div className="SwapSpan">
                  <span
                    className="material-icons "
                    tabIndex="0"
                    onClick={deleteFun}
                  >
                    delete
                  </span>
                </div>
              </div>
            </div>
          </div>
          {type !== "text" && type !== "AnimatedText" && (
            <div className="FurtherActions" data_set="Flip_object">
              <div
                className="FurtherActionInner FurtherActionInnerButton"
                data_set="Flip_object"
              >
                <div className="actionIconStyle">
                  <div className="SwapSpan">
                    <span
                      className="material-icons"
                      tabIndex="0"
                      onClick={FlipFun}
                    >
                      flip
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {type !== "AnimatedText" && (
            <div className="FurtherActions" data_set="Setting_object">
              <div
                className="FurtherActionInner FurtherActionInnerButton"
                data_set="Setting_object"
              >
                <div className="actionIconStyle">
                  <div className="SwapSpan" onClick={SettingShow}>
                    <span className="material-icons" tabIndex="0">
                      settings
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {type === "Character" && (
            <div className="FurtherActions" data_set="lock_object">
              <div
                className="FurtherActionInner FurtherActionInnerButton"
                data_set="lock_object"
              >
                <div onClick={EditModernCharacter} className="actionIconStyle">
                  <span
                    className="material-icons"
                    style={{ marginTop: "6px" }}
                    tabIndex="0"
                  >
                    face
                  </span>
                </div>
              </div>
            </div>
          )}

          {type === "Character" && (
            <div className="FurtherActions" data_set="lock_object">
              <div
                className="FurtherActionInner FurtherActionInnerButton"
                data_set="lock_object"
              >
                <div onClick={audiomodal} className="actionIconStyle">
                  <span
                    className="material-icons"
                    style={{ marginTop: "6px" }}
                    tabIndex="0"
                  >
                    keyboard_voice
                  </span>
                </div>
              </div>
            </div>
          )}
          {/* {
         audios &&(
           <>
            <characterPopup/>
           </>
         )
       } */}
        </div>
      </div>
    </>
  );
};
export default Toolbar;
